import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCryptopunk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCryptopunk"><Path d="M6.5 2.5H17.5M5.5 3.5V8.5M4.5 9.5V13.5H5.5V21.5M11.5 21.5V19.5H17.5M18.5 18.5V6.5M18.5 6.5V3.5M18.5 6.5H6M18.5 6.5H21.5M10.49 14.5H10.5M15.5 15.5H11.5M11.49 9.5H11.51M15.49 9.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCryptopunk;
